//BEGIN ROSWELL COLLECTION FUNCTIONS
var site = "https://doylestaging.roswellstudios.com";
var gems = [];
var PERPAGE = 24;
var currentPage = 1;
var maxPage = 999;
var allProducts = [];
var mlvedaranonce = false;
var xcnt = 0;

function getAllProductsFromShopify(page)
{
  /*if (location.href.indexOf('collections/new') == -1 && localStorage.getItem("_products") !== null) {
    console.log('already gotten');
    var href = window.location.href;
    if (href.indexOf('/collections/') > -1)
    {
      loadAllProductsFromShopify();
    }
    return;
  }*/
  //console.log('in get ALL P');
  var d = new Date();
  var now = d.getTime();
  var existingData = JSON.parse(localStorage.getItem('_products'));
  var last = localStorage.getItem('_lastcache');
  var loginemail = $('#currentemail').val();
  var posturl = site + "/apps/getproducts";
  d = new Date();

  if (last === null)
    last = 0;



  if (existingData && existingData.products && existingData.products.length < 1000) {
      loadAllProductsFromShopify();
      return;
  }


  if (existingData && existingData && existingData.products && ((now-last)<3600000)){  //refresh every hour
    if (existingData.products.length < 1000) {
      loadAllProductsFromShopify();
      return;
    }
  }

  localStorage.setItem('_lastcache',now);
  console.log(d.getTime().toString() + ' getAllProductsFromShopify STARTING LOADING FROM SERVER CACHE');
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { colors: $('#colors').val() },
    success: function (data) {
      d = new Date();
      console.log(d.getTime());
      console.log(data);
      localStorage.setItem('_products', JSON.stringify(data));
      d = new Date();
      console.log(d.getTime());
      loadAllProductsFromShopify();
      d = new Date();
      console.log(d.getTime());
    },
    error: function(data) {
      console.log('error');
      console.log(data);
    }
  });

}

function getAllCollectionsFromShopify(page)
{

  var loginemail = $('#currentemail').val();
  var posturl = site + "/apps/getcollections";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { },
    success: function (data) {
      localStorage.setItem('_collections', JSON.stringify(data));
    },
    error: function(data) {
      console.log('error');
      console.log(data);
    }
  });

}

function loadAllProductsFromShopify()
{
  data = JSON.parse(localStorage.getItem('_products'));
  $('body').append('<div id="spancontainer"></div>');
  for (i in data.products)
  {
    $('#spancontainer').append('<span id="' + i + '" '+(data.products[i].compare_at_price?'data-compare_at_price="'+ data.products[i].compare_at_price+'"':'')+' data-position="0" data-src="' + data.products[i].image + '" class="product-index desktop-4 last tablet-half mobile-half prod-blocks ' + data.products[i].tags + '" data-title="' + data.products[i].title +'" data-price="' + '$' + data.products[i].price +'" data-price-us="' + '$' + data.products[i].price +'" data-price-ca="' + '$' + data.products[i].priceca + '" data-visible="true" data-id="' + data.products[i].id + '" data-url="' + data.products[i].url + '" data-handle="' + data.products[i].handle + '" />');
  }
  doneGettingAllProductsFromShopify();
}

function showSpanAsDiv(id)
{
  var span = $('span#'+id);
  $('div.product-index').last().after($('div.product-index').last().clone().css('display','block').show().removeClass('deleteQ'));
  $('div.product-index').last().show();
  $('div.product-index').last().find('img').attr('src',$(span).data('src'));
  $('div.product-index').last().find('img').attr('alt',$(span).data('title'));
  $('div.product-index').last().find('.product-info a h3').html($(span).data('title'));
  if (span.data('compare_at_price')) {
    $('div.product-index').last().find('.prod-price').html('<span class="money '+xcnt+++'" data-ca="'+$(span).data('price-ca')+'"  data-cah="'+$(span).data('price-ca')+'" data-currency-usd="'+$(span).data('price')+'">'+$(span).data('price')+'</span>'
    +'&nbsp;<span class="was money '+xcnt+++'"  data-currency-usd="'+span.data('compare_at_price')+'">'+span.data('compare_at_price')+'</span>');
  } else {
    $('div.product-index').last().find('.prod-price').html('<span class="money '+xcnt+++'" data-ca="'+$(span).data('price-ca')+'"  data-cah="'+$(span).data('price-ca')+'" data-currency-usd="'+$(span).data('price')+'">'+$(span).data('price')+'</span>');
  }
  $('div.product-index').last().find('a').attr('href',$(span).data('url'));
  $('div.product-index').last().find('a').attr('title',$(span).data('title'));
  $('div.product-index').last().find('a').attr('data-handle',$(span).data('handle'));
  $('div.product-index').last().attr('class',$(span).attr('class'));
  $('div.product-index').last().attr('data-position',$(span).data('position'));
}

function goLoadPage(href)
{
  if (localStorage.getItem("_collections") !== null) {
    captureAClick(href,'');
    return;
  }
  console.log('settimeout goLoadPage');
  setTimeout(function(){
    goLoadPage(href);
  }, 1000);
}


function doneGettingAllProductsFromShopify()
{
  var stringtofind = '/collections/';
  var href = window.location.href;
  if (href.indexOf(stringtofind) != -1)
  {
    goLoadPage(href);
  }
  else
  {
    filterOnPageLoad();
    sort();
    paginate();
    setUpFilters();
    hijack();
  }
}

function captureAClick(href,ele)
{
  $('li').removeClass("selectedFilter");
  $('div.option').removeClass("selectedFilter");

  var title = '';
  var description = '';
  var image = '';
  var collection = '';
  var stringtofind = '/collections/';
  history.replaceState('abc', 'xyz', href);//what?
  if (typeof href == 'undefined' || href.indexOf(stringtofind) == -1)
    return false;
  if ($('#product-loop').length == 0 || $('div.product-index').length == 0)
    return false;

  $('span.product-index').attr('filter-out','false');  //turn off filters
  if (ele == "Shop By Color")
  {
    $('#pagetype').remove();
    $('body').append('<input type="hidden" id="pagetype" value="color" />');
  }
  else if (ele == "Shop By Theme")
  {
    $('#pagetype').remove();
    $('body').append('<input type="hidden" id="pagetype" value="theme" />');
  }
  else if (href.indexOf('collections/new') != -1)
  {
    $('#pagetype').remove();
    $('body').append('<input type="hidden" id="pagetype" value="new" />');
    image = "https://cdn.shopify.com/s/files/1/1729/1415/t/2/assets/shopnew.jpg";
  }
  else if (href.indexOf('collections/all') != -1)
  {
    $('#pagetype').remove();
    $('body').append('<input type="hidden" id="pagetype" value="all" />');
    image = "https://cdn.shopify.com/s/files/1/1729/1415/t/2/assets/full-collection.jpg";
  }
  else if (href.indexOf('collections/dresses-in-a-week') != -1)
  {
    $('#pagetype').remove();
    $('body').append('<input type="hidden" id="pagetype" value="inaweek" />');
  }

  collection = href.substr(href.indexOf(stringtofind) + stringtofind.length);
  if (collection.indexOf('?') > -1)
  {
    collection = collection.substr(0,collection.indexOf('?'));
  }
  title = getCollectionTitle(collection);
  localStorage.setItem('_lastcollectiontitle', title);
  localStorage.setItem('_lastcollectionurl', href);
  description = getCollectionDescription(collection);
  image = getCollectionImage(collection);
  var prods = getCollectionProductids(collection);
  $('span.product-index').attr('data-visible','false').attr('data-position','99999');
  var position = 0;
  for (i in prods)
  {
    position++;
    if (($('#pagetype').val() != 'color') || (!$('span.product-index[data-id="' + prods[i] + '"]').hasClass('color-MASTER')))
    {
      $('span.product-index[data-id="' + prods[i] + '"]')
      .attr('data-visible','true')
      .attr('data-position',position);
    }
  }


  $(document).prop('title', description);//title + ' - Gather & Gown');
  $('.page-title').html(title);
  $('.s1').html(description);
  if (image != '')
    $('.category-header').find('img').attr('src',image);
  else
    $('.category-header').find('img').attr('src','//cdn.shopify.com/s/files/1/1729/1415/t/2/assets/collection-banner-1.jpg?692070689962484996');
  $('meta[name=description]').attr('content', description);

  if ($('html').hasClass('shifter-open'))
    $('.shifter-handle').click();

  filter();
  sort();
  paginate();
  setUpFilters();
  hijack();
  return true;
}

function getCollectionProductids(handle)
{
  var arr = [];
  var collections = JSON.parse(localStorage.getItem('_collections')).collections;
  for (i in collections)
  {
    if (collections[i].name == handle)
    {
      for (j in collections[i].products)
      {
        arr.push(collections[i].products[j]);
      }
    }
  }
  return arr;
}

function getCollectionTitle(handle)
{
  var title = '';
  var collections = JSON.parse(localStorage.getItem('_collections')).collections;
  for (i in collections)
  {
    if (collections[i].name == handle)
    {
      title = collections[i].title
    }
  }
  return title;
}

function getCollectionDescription(handle)
{
  var title = '';
  var collections = JSON.parse(localStorage.getItem('_collections')).collections;
  //so that gets done every time?
  for (i in collections)
  {
    if (collections[i].name == handle)
    {
      title = $('<p>'+collections[i].description+'</p>').text();
      //title can not contain HTML
      //could just return title
      //or the collection
      //-description may or may not contain html
    }
  }
  return title;
}

function getCollectionImage(handle)
{
  var title = '';
  var collections = JSON.parse(localStorage.getItem('_collections')).collections;
  for (i in collections)
  {
    if (collections[i].name == handle)
    {
      title = collections[i].image;
    }
  }
  return title;
}

function paginate()
{

  var ptml = '';

  if (getUrlParameter('view') == 'all')
  {
    return;
  }
  $('#paginateHolder').show();
  var allCount = 0;
  var visibleCount = 0;
  var counterCount = 0;
  var page = 0;

  $('span.product-index[data-visible="true"]').each(function(event){
    allCount++;
    if ($(this).attr('filter-out') != "true")
    {
      visibleCount++;
    }
  });
  if (allCount > 0)
    $('div.product-index').addClass('deleteQ');
  counterCount = 0;
  allCount = 0;
  $('span.product-index[data-visible="true"]').each(function(event){
    if ($(this).attr('filter-out') == "true")
      return;

    allCount++;

    if ((allCount >= ((currentPage-1)*PERPAGE)+1) && (allCount <= currentPage*PERPAGE))
    {
      console.log('showSpanAsDiv');
      showSpanAsDiv($(this).attr("id"));
      counterCount++;
    }

    if (counterCount >= PERPAGE)
      return false;
  });
  $('.deleteQ:gt(0)').remove();
  getOtherCurrencyPrices();
  if (visibleCount <= PERPAGE)
  {
    currentPage = 1;
    $('#paginateHolder').html('');
    return;
  }
  maxPage = Math.floor(visibleCount / PERPAGE);
  var prev = parseInt(currentPage) - 1;
  if (currentPage > 1)
    ptml += '<span class="prev"><a href="javascript:goto(' + prev + ')" title=""><i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;</a></span>';

  var beforedotdot = 0;
  var afterdotdot = 0;

  if (maxPage > 10 && Math.abs(maxPage - currentPage) > 3 && currentPage > 3)
  {
    beforedotdot = 3;
    afterdotdot = currentPage + 2
  }
  else if (maxPage > 5)
  {
    if (Math.abs(maxPage - 1) < 3)
      afterdotdot = currentPage + 1;
    else
      beforedotdot = 4;
  }


  while (page++ * PERPAGE < visibleCount)
  {
    if (page == afterdotdot || page == beforedotdot)
      ptml += '<span class="deco">…</span>';
    else if ((page != 1 && page != maxPage && page != currentPage) && ((page > beforedotdot && page < currentPage-1) || (page > currentPage+1)))
    {}
    else
      ptml += '<span class="page paginatePage" data-number="' + page + '"><a title>' + page + '</a></span>';
  }

  var next = parseInt(currentPage) + 1;
  if (currentPage < maxPage)
    ptml += '<span class="next"><a href="javascript:goto(' + next + ')" title="">&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a></span>';
  var pbuttons = '<div class="page-btns">';
  if (currentPage > 1)
    pbuttons += '<a class="first-page view-all" style="margin-left: 4px; display: none;" href="javascript:goto(1)">First Page</a>';
  pbuttons += '<a href="' + window.location + '/?view=all" style="margin-left: 4px;" class="view-all">View all</a></div>';

  ptml = '<div class="pagination">' + pbuttons + ptml + '</div>';

  $('#paginateHolder').html(ptml);

  $('.paginatePage[data-number="' + currentPage + '"]').addClass('selectedFilter');

  $('#paginateHolder .paginatePage').click(function(event){
    currentPage = $(this).data('number');
    Everything();
    return false;
  });

  $('#paginateHolder span, .page-btns a, a.view-less').click(function(){
    window.scrollTo(0, 0);
  });
}

function goto(pg)
{
  if (pg == 999)
    pg = $('.paginatePage').last().find('a').html();
  currentPage = pg;
  Everything();
}

function pullDivsTogether()
{
  var perRow = 4;
  if ($('.product-index').hasClass('desktop-3'))
    perRow = 4;
  else if ($('.product-index').hasClass('desktop-2'))
    perRow = 6;
  else if ($('.product-index').hasClass('desktop-4'))
    perRow = 3;

  var visibleFound = 0;
  $('.product-index:visible').each(function(event){
    $(this).removeClass('last').removeClass('first');

    if ($(this).css('display') == 'none')
      return true;
    visibleFound++;
    if (visibleFound % perRow == 1)
      $(this).addClass('first');
    else if (visibleFound % perRow == 0)
      $(this).addClass('last');
  });

}

function sort()
{
  var attr = '';
  var desc = false;
  var isNumeric = false;

  switch($('#sort-by').val()) {
    case 'title-descending':
      attr = 'data-alpha';
      desc = true;
      break;
    case 'created-descending':
      attr = 'data-id';
      isNumeric = true;
      desc = true;
      break;
    case 'price-descending':
      attr = 'data-price';
      isNumeric = true;
      desc = true;
      break;
    case 'price-ascending':
      attr = 'data-price';
      isNumeric = true;
      break;
    case 'manual':
      attr = 'data-position';
      isNumeric = true;
      break;
    default:
      return;
  }
  var divs = $('span.product-index');
  divs.sort(function (a, b) {
    var contentA =(isNumeric)?parseInt($(a).attr(attr).replace('$','')) : $(a).attr(attr);
    var contentB =(isNumeric)?parseInt($(b).attr(attr).replace('$','')) : $(b).attr(attr);
    if (desc == true)
      return (contentA < contentB) ? 1 : (contentA > contentB) ? -1 : 0;
    else
      return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
  });
  $('#spancontainer').html(divs);
}

function filterOnPageLoad()
{

}

function filter()
{
  var gems = [];
  var parent = [];
  var colors = [];
  var clss = $(this).find('a').text().toLowerCase();
  var clsswithoutlastcharacter = clss.substring(0,clss.length-1);//this to fix singlular vs plural, just do it on everything
  var clsses = clss.substring(0,clss.length-2);//this to fix singlular vs plural, just do it on everything

  $('span.product-index').attr('filter-out','false');  //turn off filters

  $('.accordion-side-menu li, .m-list-option-container .option').each(function(event){
    if ($(this).hasClass("selectedFilter"))
    {
      var pairint = $(this).parent().find("label").html().toLowerCase();
      pairint = pairint.substring(0,pairint.indexOf('<span'));
      if ($(this).parent().find("label").html().toLowerCase().indexOf('color') > -1 )
      {
        var valyou = $(this).find('a').text().split(" ").join("_").split("/").join("--");
        valyou = 'color-' + valyou;
        colors.push(valyou);
        valyou = valyou.toLowerCase();
        colors.push(valyou);
      }
      else
      {

        var valyou = $(this).find('a').text().split(" ").join("_").split("/").join("--");

        gems.push(valyou);
        gems.push(valyou.substring(0,valyou.length-1));
        gems.push(valyou.substring(0,valyou.length-2));
        valyou = $(this).find('a').text().split(" ").join("_").split("/").join("--").toLowerCase();
        gems.push(valyou);
        gems.push(valyou.substring(0,valyou.length-1));
        gems.push(valyou.substring(0,valyou.length-2));
        parent.push(pairint);
        parent.push(pairint);
        parent.push(pairint);
        parent.push(pairint);
        parent.push(pairint);
        parent.push(pairint);
      }
    }
  });

  if (gems.length == 0)
  {
    console.log('gems == 0');
    $('span.product-index').each(function(event){
      $(this).attr('filter-out','false');
    });
  }
  else
  {
    var found = false;
    $('span.product-index').each(function(event){
      found = false;
      for (i in gems)
      {
        //evidently some stuff is tagged with - in place of a space
        if ($(this).hasClass(gems[i]) || $(this).hasClass(gems[i].toUpperCase()) || $(this).hasClass(gems[i].replace('_','-')) || $(this).hasClass(gems[i].toUpperCase().replace('_','-')))
        {
          found = true;  //dont break, let it ride
        }
      }
      if (found)
      {
        $(this).attr('filter-out','false');
      }
      else
      {
        $(this).attr('filter-out','true');
      }
    });
  }

  if ($('#pagetype').val() == 'theme')
  {
    $('#product-loop').removeClass('desktop-10 tablet-5 mobile-3');
    $('#product-loop').addClass('desktop-12 tablet-6 mobile-3');

    $('span.product-index[filter-out="false"]').each(function(event){
      if ($(this).hasClass('color-MASTER'))
        $(this).attr('filter-out','true');
    });
  }
  else if ($('#pagetype').val() == 'clearance') {

    $('#product-loop').removeClass('desktop-12 tablet-6 mobile-3');
    $('#product-loop').addClass('desktop-10 tablet-5 mobile-3');
    $('span.product-index[filter-out="false"]').each(function(event){
      if ($(this).hasClass('color-MASTER'))
        $(this).attr('filter-out','true');
    });
  } else {
    $('#product-loop').removeClass('desktop-12 tablet-6 mobile-3');
    $('#product-loop').addClass('desktop-10 tablet-5 mobile-3');
  }

  if (colors.length == 0)
  {

    if ($('#pagetype').val() == 'new' || $('#pagetype').val() == 'all')
    {
      $('span.product-index[filter-out="false"]').each(function(event){
        if (!$(this).hasClass('color-MASTER'))
          $(this).attr('filter-out','true');
      });
    }
    return false;
  }

  var found = false;
  //$('span.product-index[data-visible="true"]').each(function(event){
  $('span.product-index[filter-out="false"]').each(function(event){
    found = false;
    for (i in colors)
    {
      if ($(this).hasClass(colors[i].split('--').join('/')))
        found = true;  //dont break, let it ride
    }
    if (found)
    {
    }
    else
    {
      $(this).attr('filter-out','true');
    }
  });

  $('span.product-index[filter-out="false"]').attr('data-visible','true'); //this missing was resulting in blank PLP alot of times
}

function Everything()
{
  filter();
  sort();
  paginate();
  pullDivsTogether();
  hijack();
}

function unpaginate()
{
  filter();
  sort();
  $('div.product-index').addClass('deleteQ');
  $('span.product-index[data-visible="true"]').each(function(event){
    if ($(this).attr('filter-out') == "true")
      return;
    showSpanAsDiv($(this).attr("id"));
  });
  $('.deleteQ:gt(0)').remove();

  pullDivsTogether();
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return '';//if you return anything, you have  to return something.
};

function hijack() {
  console.log($('.page-btns a'));
  $('.page-btns a').each(function(event){
    if ($(this).html().toLowerCase() == 'view all')
    {
      $(this).click(function(event){
        console.log('view all');
        unpaginate();
        var ptml = '<div class="page-btns"><a href="' + window.location + '/?view=less" style="margin-left: 4px;" class="view-less">View less</a></div>';
        $('#paginateHolder').html(ptml);
        hijack();
        event.stopPropagation();
        return false;
      });
    }
    if ($(this).html() == 'View less')
    {
      $(this).click(function(event){
        Everything();
        event.stopPropagation();
        return false;
      });
    }
  });
}

function getUnique(a) {
  var b = [a[0]], i, j, tmp;
  for (i = 1; i < a.length; i++) {
    tmp = 1;
    for (j = 0; j < b.length; j++) {
      if (a[i] == b[j]) {
        tmp = 0;
        break;
      }
    }
    if (tmp) {
      b.push(a[i]);
    }
  }
  return b;
}

function setUpFilters() {
  if ($('.filter-popup').length > 0)
  {
    $('.filter-popup').show();
  }
  $('ul.accordion-side-menu').show();
  $('ul.accordion-side-menu').eq(0).show();
  $('div.list-option').find("label:contains('Color')").parent().show();
  $('ul.accordion-side-menu').eq(3).hide();  //won says hide everywhere in 5/4 email REMOVE DELIVERY FILTER FROM ALL COLLECTIONS
  $('div.list-option').find("label:contains('Delivery')").parent().hide();
  if ($('#pagetype').val() == 'color')
  {
    $('ul.accordion-side-menu').eq(0).hide();
    $('div.list-option').find("label:contains('Color')").parent().hide();
  }
  else if ($('#pagetype').val() == 'theme')
  {
    $('ul.accordion-side-menu').hide();
    if ($('.filter-popup').length > 0)
      $('.filter-popup').hide();
  }
  else
  {
    $('ul.accordion-side-menu').eq(0).show();
    var colors = [];
    //$('span.product-index[data-visible="true"]').each(function(event){
    $('span.product-index').each(function(event){
      var classList = $(this).attr('class').split(/\s+/);
      for (i = 0; i < classList.length; i++) {
        if(classList[i].length > 0){
          var c = classList[i];
          if (c.indexOf("color-") > -1)
            colors.push(c.replace('color-',''));
        }
      }
    });
    colors = getUnique(colors);
    colors.sort();
    $('ul.accordion-side-menu').eq(0).find('li').remove();
    $('div.list-option').eq(0).find('div').remove();
    $.each( colors, function( index, value ){
      if (value) {
        value = value.split("_").join(" ").split("--").join("/");
        if (value != 'MASTER')
        {
          $('ul.accordion-side-menu').eq(0).append('<li><a href="/user/messages"><span class="tab">' + value + '</span></a></li>');
          $('div.list-option').eq(0).append('<div class="option ' + value + '"> <a>' + value + '</a> <div class="radio-sub"></div></div>');
        }
      }
    });
  }
  $('#collection-sidebar ul').each(function(event){
    if (!$(this).hasClass('accordion-side-menu'))
      $(this).addClass('accordion-side-menu');
  });
  if (window.location.href.indexOf("women") > -1 )//.includes("women"))
    $('.accordion-side-menu').find('label:contains("Men")').parent().hide();
  else if (window.location.href.indexOf("men") > -1 )//.includes("men"))
    $('.accordion-side-menu').find('label:contains("Women")').parent().hide();

  if($(window).width<768){
    $('#collection-sidebar').css('display','block');
  }

  $('.accordion-side-menu li').each(function(event){
    var clss = $(this).find('a').text().toLowerCase().split(" ").join("_").split("/").join("--").replace("'","\\'").replace("&","\\&").replace(".","\\.").replace("+","\\+"); //need to regex this
    //var clss = CSS.escape($(this).find('a').text().toLowerCase().split(" ").join("_"));
    var clsswithoutlastcharacter = clss.substring(0,clss.length-1);//this to fix singlular vs plural, just do it on everything
    var clsses = clss.substring(0,clss.length-2);//this to fix singlular vs plural, just do it on everything
    if (clsswithoutlastcharacter.substring(clsswithoutlastcharacter.length-1,clsswithoutlastcharacter.length) == '\\')
      clsswithoutlastcharacter = clss;
    if (clsses.substring(clsses.length-1,clsses.length) == '\\')
      clsses = clss;

    var pairint = $(this).parent().find("label").html().toLowerCase();
    if ((pairint == 'men') || (pairint == 'women'))
    {
      clss += '.' + pairint;
      clsswithoutlastcharacter += '.' + pairint;
      clsses += '.' + pairint;
    }
    if (($('div.product-index.'+clss).length == 0) && ($('div.product-index.'+clsswithoutlastcharacter).length == 0) && ($('div.product-index.'+clsses).length == 0))
      if (!((clss.toLowerCase().indexOf("all_") > -1) && (clss.toLowerCase().indexOf("accesso") == -1) && ((window.location.href.indexOf("new-arrivals") > -1 ) || (window.location.href.indexOf("sale") > -1 ))))
        null;
  });

  $('.clearall').remove();
  if ($('.accordion-side-menu').length > 0)
    $('.accordion-side-menu').find('label').append('<span id="clearall" class="clearall">Clear All</span>');

  $('label #clearall, .reset-btn').click(function(event){
    $(this).parent().parent().find('li').each(function(event){
      $(this).removeClass("selectedFilter");
      $('div.option').removeClass("selectedFilter");
    });
    Everything();
  });

  $( "#sort-by" ).unbind();
  $('#sort-by').change(function(event){
    Everything();
    event.stopPropagation();
    return false;
  });

  $('.accordion-side-menu li, .m-list-option-container .option').unbind();
  $('.accordion-side-menu li, .m-list-option-container .option').click(function(event){
    if ($(this).hasClass("selectedFilter"))
    {
      $(this).removeClass("selectedFilter")
    }
    else
    {
      $(this).addClass("selectedFilter")
    }
    currentPage = 1;
    Everything();
    event.stopPropagation();
    return false;
  });

}

function fixsearchurls()
{
  $('.prod-image a').each(function(event){
    console.log($(this).attr('title'));
    data = JSON.parse(localStorage.getItem('_products'));
    if (data) for (i in data.products)
    {
      if (data.products[i].title == $(this).attr('title'))
        $(this).attr('href',data.products[i].url);
    }
  });
}
//END ROSWELL COLLECTION FUNCTIONS

function captureCu()
{
  $('span.money').show();
  console.log('setTimeout captureCu');
  setTimeout(function(){
    $('select#currencies').unbind();
    $('select#currencies').on('change', function (e) {
      cadcart();
      var valueSelected = this.value;
      Currency.cookie.write(valueSelected);

      $('span.money').each(function(event){
        if (valueSelected == 'CAD')
        {
          if ($(this).data('ca')==undefined)
            return;
          var val = $(this).data('ca').replace('$','').toString();
          val = val / Currency.rates['CAD'];
          val = val + .02;
          val = '$' + Math.floor(val) + '.00 CAD';
          $(this).data('currency-cad','$' + val);
          $(this).text(val);
        }
        else
        {
          $(this).text($(this).data('currency-usd'));
        }
      });
    });
    $('select#currencies').trigger('change');
  }, 5000);

}

function cadcart()
{
  var valueSelected = $('select#currencies').val();
  if (Currency.cookie.read() != valueSelected)
  {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      for (var i in cart.items)
      {
        getCADproduct(cart.items[i].id,true)
      }
    });
  }
}

function captureCuPDPJustSwatchChange()
{
  if (window.location.href.indexOf('/collections/') > -1)
    return;

  var valr = "";
  var original = $("select[name='id']").find('option:eq(0)').text();
  var textstring = $("select[name='id']").find('option:eq(1)').text();
  if (textstring.indexOf('$') == -1)
    original = $('.product-price.x2').find('span.money').text().replace('$','');
  else
    original = original.substr(original.indexOf('$'));//+1);

  original = original.replace('-','').trim().replace('$','');

  if (textstring.indexOf('$') > -1 && textstring.indexOf('/ ca') > -1)
  {
    valr = textstring.substr(textstring.indexOf('$')+1);
    $('span.money').each(function(event){
      $(this).attr('data-ca',valr);
      $(this).attr('data-us',original);
    });
  }
  else
  {
    $('span.money').each(function(event){
      $(this).attr('data-ca',original);
      $(this).attr('data-us',original);
    });
  }
}

function captureCuPDP()
{
  console.log('setTimeout captureCuPDP');
  setTimeout(function(){
    var count = 0;
    var valr = "";

    var original = $("select[name='id']").find('option:eq(0)').text();
    var textstring = $("select[name='id']").find('option:eq(1)').text();
    if (textstring.indexOf('$') == -1)
      original = $('.product-price.x2').find('span.money').text().replace('$','');
    else
      original = original.substr(original.indexOf('$'));//+1);

    original = original.replace('-','').trim().replace('$','');
    if (textstring.indexOf('$') > -1 && textstring.indexOf('/ ca') > -1)
    {
      valr = textstring.substr(textstring.indexOf('$')+1);
      $('span.money').each(function(event){
        $(this).attr('data-ca',valr);
        $(this).attr('data-us',original);
      });
    }
    else
    {
      $('span.money').each(function(event){
        $(this).attr('data-ca',original);
        $(this).attr('data-us',original);
      });
    }

    $('select#currencies').unbind();
    $('select#currencies').on('change', function (e) {
      var valueSelected = $('select#currencies').val();
      cadcart();

      Currency.cookie.write(valueSelected);
      $('span.money').each(function(event){
        if (valueSelected == 'CAD')
        {

          if ($(this).data('ca')==undefined)
          {
            captureCuPDPJustSwatchChange();
          }
          var dollhair = $(this).data('ca').toString();
          var val = dollhair.replace('$','');
          val = val / Currency.rates['CAD'];
          val = val + .02;
          if ($('#extralength').is(':checked') == true)
            val += 10;
          val = '$' + Math.floor(val) + '.00 CAD';
          if ($(this).text() != val)
          {
            dont = true;
            $(this).text(val);
            dont = false;
          }
        }
        else
        {
          if ($(this).data('us')==undefined)
          {
            captureCuPDPJustSwatchChange();
          }
          var yous = '$'+$(this).data('us');
          if ($('#extralength').is(':checked') == true)
          {
            yous = Math.floor(yous.replace('$',''));
            yous += 10;
            yous = '$' + yous.toString() + '.00';
          }

          dont = true;
          $(this).text(yous);
          $('span.money').text($(this).text());
          dont = false;

        }
      });
    });
    $('select#currencies').trigger('change');
  }, 2000);
}

$(document).ready( function () {

  var stringtofind = '/collections/';
  var href = window.location.href;
  if (href.indexOf('/search') > -1)
  {
    //if the _products are loaded (and note where that starts happening in relation to this line)
    //will turn variant= urls into simple products
    //: the variant= allows you to select other colors.
    fixsearchurls();

    //you know what would be nice: not throwing out the search results and loading every product.
    return;
  }

  if (href.indexOf(stringtofind) > -1)
    captureCu();
  else if (href.indexOf('/products/') > -1)
    captureCuPDP();
  else
  {
    $('select#currencies').on('change', function (e) {
      cadcart(); });
    //or: $('select#currencies').on('change', cadcart);
  }

  getAllProductsFromShopify(1);
  getAllCollectionsFromShopify(); //this should be called after getAllProductsFromShopify returns
  //does that mean doneGettingAllProductsFromShopify()?

  if (href.indexOf(stringtofind) == -1)
    return;

  $('#accordion a').click(function(event){
    var categ = '';
    if ($('nav.shifter-navigation:visible').length > 0)
      categ = $(this).parent().parent().prev().html();
    else
      categ = $(this).parent().parent().parent().parent().parent().parent().parent().find('a').eq(0).text();//shiiiiiiiiiit
    if (captureAClick($(this).attr('href'),categ))
    {
      event.stopPropagation();
      return false;
    }
  });
  $('#navigation a').click(function(event){
    /*var categ = '';//should be undefined

    if ($(this).parent().parent()) //you know, $() always returns a JQ array?
    	if ($(this).parent().parent().prev())// It is never not true
    	  categ = $(this).parent().parent().prev().html();
          //this doesn't return anything, possibly because the menu structure change
          //who could have guessed this would have been horribly brittle!
          */
    if (captureAClick($(this).attr('href'),$(this).closest('.dropdown').children('a').text())) {
      event.stopPropagation();
      return false;
    }
  });
});
